// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './name.pipe';
export * from './ratio.pipe';
export * from './round.pipe';
export * from './sort.pipe';
export * from './text-color.pipe';
// @endindex